import type { VariableType } from "@/domains/tenant";

export const VARIABLE_TYPES: VariableType[] = [
  "string",
  "text",
  "number",
  "integer",
  "boolean",
  "date",
  "datetime",
  "enum",
  "array",
  "uuid",
  "json",
];
